<template>
  <!-- Footer -->
  <mdb-footer color="white" class="font-small">
    <mdb-container class="text-left">
      <mdb-row center class="d-flex justify-content-between">
        <mdb-col sm="2">
          <h5 class="title">Excellence</h5>
          <ul>
            <!--  <li class="list-unstyled"><a href="#!">About us</a></li> -->
          </ul>
        </mdb-col>
        <mdb-col sm="2">
          <ul>
            <li class="list-unstyled">
              <a href="/skills">10 Critical Skills</a>
            </li>
          </ul>
        </mdb-col>
        <mdb-col sm="2">
          <ul>
            <li class="list-unstyled">
              <router-link to="/course/How-to-find-clients">How to find clients</router-link>
            </li>
            <li class="list-unstyled">
              <router-link to="/course/How-to-sell-and-win">How to sell & win</router-link>
            </li>
            <li class="list-unstyled">
              <router-link to="/course/How-to-sell-more">How to sell more</router-link>
            </li>
          </ul>
        </mdb-col>
        <mdb-col sm="2">
          <ul class>
            <li class="list-unstyled">
              <router-link to="/community">Community</router-link>
            </li>
            <li class="list-unstyled">
              <router-link to="/podcasts">Sales Podcasts</router-link>
            </li>
          </ul>
        </mdb-col>
        <mdb-col sm="2">
          <h5 class="title">legal</h5>
          <ul>
            <li class="list-unstyled">
              <router-link to="/subscriber-terms-and-conditions">Subscriber Terms and Conditions</router-link>
            </li>
            <li class="list-unstyled">
              <router-link to="/website-terms-and-conditions">Website Terms and Conditions</router-link>
            </li>

            <li class="list-unstyled">
              <router-link to="/privacy-and-cookie-policy">Privacy & Cookie Policy</router-link>
            </li>
          </ul>
        </mdb-col>
      </mdb-row>
    </mdb-container>
    <div class="footer-copyright text-center py-3">
      <mdb-container>
        <span class="float-left">Exsellance 2019</span>
        <span>
          <a class="fb-ic mr-3" role="button">
            <mdb-icon fab icon="facebook-f" size="lg" />
          </a>
          <a class="tw-ic mr-3" role="button">
            <mdb-icon fab icon="twitter" size="lg" />
          </a>
          <a class="gplus-ic mr-3" role="button">
            <mdb-icon fab icon="google-plus-g" size="lg" />
          </a>
        </span>
        <span class="float-right">Terms & Privacy</span>
      </mdb-container>
    </div>
  </mdb-footer>
  <!-- Footer -->
</template>


<script>
import { mdbFooter, mdbContainer, mdbRow, mdbCol, mdbIcon } from "mdbvue";
export default {
  name: "Footer",
  components: {
    mdbFooter,
    mdbContainer,
    mdbRow,
    mdbCol,
    mdbIcon
  }
};
</script>